import WorkflowImage from "assets/images/workflow-image.jpg";

export default function HowItsWorkSection() {
  return (
    <section className="workflow-section flex-column d-flex items-center justify-center">
      <div className="workflow-scroll-element" />
      <h2 className="features-title">A Seamless End-to-End Workflow</h2>
      <div className="custom-container d-flex items-center width-100">
        <div className="workflow-steps d-flex flex-column">
          <div className="workflow-step d-flex items-start ">
            <div className="workflow-step-number d-flex items-center justify-center">1</div>
            <div className="workflow-step-content">
              <div className="workflow-step-title">Snap & Scan</div>
              <div className="workflow-step-desc">
                At closing time, print your lottery ticket detail report and
                take a photo with the LottoReco app. Our AI instantly reads
                ticket counts and values.
              </div>
            </div>
          </div>
          <div className="workflow-step d-flex items-start ">
            <div className="workflow-step-number d-flex items-center justify-center">2</div>
            <div className="workflow-step-content">
              <div className="workflow-step-title">Auto-Reconcile</div>
              <div className="workflow-step-desc">
                LottoReco instantly matches your data against POS sales and
                state records. Get a clear summary of what was sold, what's in
                the register, and what remains.
              </div>
            </div>
          </div>
          <div className="workflow-step d-flex items-start ">
            <div className="workflow-step-number d-flex items-center justify-center">3</div>
            <div className="workflow-step-content">
              <div className="workflow-step-title">Review Alerts</div>
              <div className="workflow-step-desc">
                If everything matches, you're done! If not, LottoReco highlights
                discrepancies with simple alerts like "Game #123 – 1 ticket
                missing, $5 discrepancy."
              </div>
            </div>
          </div>
          <div className="workflow-step d-flex items-start ">
            <div className="workflow-step-number d-flex items-center justify-center disabled-before">4</div>
            <div className="workflow-step-content">
              <div className="workflow-step-title">Relax & Save</div>
              <div className="workflow-step-desc">
                Close your shift with confidence. All data is securely stored in
                the cloud with real-time reports, daily summaries, and profit
                calculations.
              </div>
            </div>
          </div>
        </div>
        <div className="workflow-image-placeholder d-flex items-center justify-center">
          <img src={WorkflowImage} alt="Workflow Image" />
        </div>
      </div>
    </section>
  );
}
